// src/hooks/hotelMealPlans/useForceDeleteAllHotelMealPlans.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { forceDeleteAllHotelMealPlans as forceDeleteAllHotelMealPlansAPI } from "../../api/apiHotelMealPlans";
import parseError from "../../utils/parseError";

const useForceDeleteAllHotelMealPlans = () => {
    const queryClient = useQueryClient();

    const { mutate: forceDeleteAll, isPending: isForceDeleteAll } = useMutation({
        mutationFn: forceDeleteAllHotelMealPlansAPI,
        onSuccess: (res) => {
            const message = res?.message || "Selected hotel meal plans permanently deleted";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["hotelMealPlans"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to permanently delete selected hotel meal plans");
        },
    });

    return { forceDeleteAllHotelMealPlans: forceDeleteAll, isForceDeleteAll };
};

export default useForceDeleteAllHotelMealPlans;
